const createSetNotificationState = (state, payload) => {
  const newPriority = payload.priority ?? 1;
  const oldPriority = state.priority;
  const isPriorityLower = newPriority < oldPriority;
  const isCloseRequest = state.isShown && !payload.isShown;
  const canUpdate = !isPriorityLower || isCloseRequest;

  if (!canUpdate) {
    return state;
  }

  return {
    ...payload,
    priority: newPriority
  };
};

export default createSetNotificationState;
